module.exports = __webpack_public_path__ + "assets/img/product-index1.4ae79394.png";